import { getInstrumentBehavior } from './InstrumentBehaviorRegistry.js';

/**
 * Applies specific instrument logic (doublings, tuning, etc.)
 * based on instrument ID and role.
 *
 * @param {Array} events - The generated events for this instrument.
 * @param {Object} assignment - The allocation assignment object { instrument, ... }
 * @param {string} role - The abstract role being fulfilled.
 * @param {Array} sectionChords - The chord progression for the section (for context).
 * @returns {Array} Modified events.
 */
export const applyInstrumentBehaviors = (events, assignment, role, sectionChords) => {
    let modifiedEvents = events;
    const instrumentId = assignment.instrument.id;

    const behaviorFn = getInstrumentBehavior(instrumentId);
    if (behaviorFn) {
        modifiedEvents = behaviorFn(modifiedEvents, assignment, role, sectionChords);
    }

    return modifiedEvents;
};
